import {createTheme} from '@mui/material';
import {createBreakpoints} from '@mui/system';

import {Tokens} from '../../types/generated/Tokens';

import {palette, typography, components, breakpoints as breakpointValues, shape} from './variables';

export const createUniversalTheme = (tokens: Tokens, themeName: string) => {
  const breakpoints = createBreakpoints(breakpointValues(tokens.breakpoints));
  return createTheme({
    themeName,
    breakpoints,
    palette: palette(tokens.palette, tokens.icon, tokens.extraColors),
    shape: shape(tokens.border),
    typography: typography(tokens.typography, tokens.font, breakpoints),
    components: components(tokens, breakpoints)
  });
};
